@if (translatableFormControls()) {
  <div class="relative flex flex-col w-full rounded-md">
    <!-- Header section with language selector and editor button -->
    <div class="w-full px-2 rounded-t-lg bg-white/10 shrink-0">
      <div class="flex flex-row items-center justify-between">
        <div class="relative w-1/2 h-8 pt-2">
          <nrc-input-language-selector
            class="absolute z-20"
            [formControl]="languageCodeFormControl"
            [options]="languageCodes"
            [textSize]="inputLanguageSelectorTextSize.SMALL"
            (languageChanged)="handleLanguageChangeEvent($event)"
          />
        </div>

        <div class="flex items-center justify-center w-8 h-8">
          <nrc-button
            class="relative flex w-7 h-7"
            [icon]="'editor'"
            [buttonType]="buttonType.ICON"
            [role]="actionRole.TRANSPARENT_SECONDARY"
            [tooltipText]="'Expand Advanced mode'"
            (clickEvent)="toggleWYSIWYGModal()"
          />
        </div>
      </div>
    </div>

    <!-- Content section with scrollable container -->
    <div class="flex flex-row flex-grow w-full min-h-0">
      <div class="relative flex flex-col w-full">
        <div class="h-full rounded-lg">
          <nrc-wysiwyg-editor
            [hideToolbar]="true"
            [value]="currentValuePerLanguageCode()"
            [minimumHeight]="'9rem'"
            [maximumHeight]="'9rem'"
            [formControl]="translatableFormControls()[currentLanguageCode()] | formControl"
          />
        </div>
      </div>
    </div>
  </div>
}

<ng-template #wysiwygModalContent>
  @if (languageCodes | isNonEmptyArray) {
    <div class="absolute z-30 -ml-4 -translate-x-1/2 top-4 left-1/2">
      <div class="flex items-end justify-center">
        <div class="flex space-x-1">
          <nrc-input-language-selector
            class=""
            [options]="languageCodes"
            [formControl]="languageCodeFormControl"
            [value]="currentLanguageCode()"
            (languageChanged)="handleLanguageChangeEvent($event)"
          />

          <nrc-button
            class="relative flex justify-end w-8 h-8 transition-transform duration-250"
            [icon]="'translate'"
            [buttonType]="buttonType.ICON"
            [role]="actionRole.TRANSPARENT_SECONDARY"
            (clickEvent)="toggleAutoTranslateModal()"
          />
        </div>
      </div>
    </div>
  }

  <nrc-wysiwyg-editor
    class="relative z-20 flex flex-col flex-1 min-h-0"
    [formControl]="translatableFormControls()[currentLanguageCode()] | formControl"
    (valueChanged)="handleValueChangedEvent($event)"
  />
</ng-template>


@if (isTranslationModalOpen()) {
  <nrc-auto-translate
    class="flex flex-col justify-around grow"
    [languageCodes]="languageCodes"
    [selectedLanguageCode]="currentLanguageCode()"
    [textTranslation]="translatableFormControls()[currentLanguageCode()].value ?? ''"
    [modalTexts]="{
      title: 'PAGES.AREA_DETAIL.AREA_DETAIL_MODALS.INPUT_TRANSLATION.MODAL_TITLE' | translate,
      description: 'PAGES.AREA_DETAIL.AREA_DETAIL_MODALS.INPUT_TRANSLATION.MODAL_DESCRIPTION' | translate,
      subline: 'PAGES.AREA_DETAIL.AREA_DETAIL_MODALS.INPUT_TRANSLATION.MODAL_FIELDS_DESCRIPTION' | translate
    }"
    (autoTranslateResult)="handleAutoTranslateResult($event)"
  />
}
